import {mkObservable, Observer } from "./Observable";
export const throwError = <T>(err: any) => mkObservable<T>((observer: Observer<T>) => {
  observer.error(err);
});
